import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
export function SelectedColumnFilter(props) {
    const { filter, value, onChange, isValid, ref2 } = props;
    const inputRef = useRef(null);
    useImperativeHandle(ref2, ()=>({
            focus: ()=>{
                inputRef.current?.focus();
                inputRef.current?.select();
            }
        }));
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            filter.info && /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                        icon: faInfoCircle
                    }),
                    " ",
                    filter.info
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classNames('form-group'),
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "text",
                        className: classNames('form-control form-control-sm', {
                            'border-danger': !isValid
                        }),
                        autoComplete: "off",
                        ref: inputRef,
                        value: value,
                        onChange: onChange,
                        ...filter.inputProps
                    }),
                    !isValid && /*#__PURE__*/ _jsx("div", {
                        className: "text-danger",
                        children: filter.validationMsg
                    })
                ]
            })
        ]
    });
}
